import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    Box, SpaceBetween, 
    ExpandableSection
} from '@amzn/awsui-components-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import DownloadableFileListComponent from '../Templates/components/DownloadableFileListComponent';


const FlexicoTransactionFileListViewer = (props) => {

    const userAuthenticationDetails = useAuth();
    const history = useHistory();
    const dispatch = useDispatch()
    
    const [error, setError] = useState(false);
  
    const userId = useSelector((globalState) => globalState.auth.userId);

    const fileDetails = (
      <>
        {
          props?.transactionDetails && <Box>
            <SpaceBetween direction="horizontal" size="m">
              {
                props?.transactionDetails?.filePath && props?.transactionDetails.bucketName && <ExpandableSection headerText="Input files">
                  <SpaceBetween direction="vertical">
                    <DownloadableFileListComponent filePaths={props?.transactionDetails.filePath?.split(',')} bucketName={props?.transactionDetails.bucketName}></DownloadableFileListComponent>
                  </SpaceBetween>
                </ExpandableSection>
              }

            </SpaceBetween>
          </Box> 
        }
      </>
    )

    return(
        <Box textAlign="center">
            {
                error ?
                    <Box variant="h1" color="text-status-error">Invalid id</Box> :
                    <Box> {fileDetails}</Box>
            }
        </Box>
    )
}



export default FlexicoTransactionFileListViewer

